import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { graphql } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import { Link, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { purgeStoredState } from 'redux-persist';
import persistConfig from '../../persistConfig';
import RequestUserForm from '../../components/RequestUserForm';
import Icon from '../../components/Icon';
import Container from '../../components/Container';
import Header from '../../components/Header';
import { SimpleLoadingComponent } from '../../utils/apollo';
import RequestHSUserMutation from './request-hs-user-mutation';

class HSRequestUserPage extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      state: PropTypes.shape({
        linkBack: PropTypes.object,
        parentLinkBack: PropTypes.object,
      }),
    }),
    node: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    mutateRequestHSUser: PropTypes.func.isRequired,
    history: PropTypes.shape({
      replace: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    requesting: false,
    userExists: false,
    isError: false,
    isDone: false,
  };

  getLinkBack() {
    return get(this.props, 'location.state.linkBack', null);
  }

  getParentLinkBack() {
    return get(this.props, 'location.state.parentLinkBack', null);
  }

  navigateToCaller() {
    const path = this.getLinkBack() || { pathname: `/hs/institution/${this.props.match.params.id}/` };
    this.props.history.push({ pathname: path.pathname, state: { linkBack: this.getParentLinkBack() } });
  }

  _handleCancel = () => {
    this.navigateToCaller();
  };

  /* istanbul ignore next */
  _handleDone = async () => {
    const path = process.env.HS_LOGIN_URL;
    await purgeStoredState(persistConfig);
    this.props.history.replace('/');
    window.location = path;
  };

  _handleSave = ({ firstName, lastName, email, jobTitle, isCitizenOfEU, hasAgreedToTermsOfUse, hasAgreedToPrivacyPolicy }) => {
    const { mutateRequestHSUser, node } = this.props;
    const onFailure = (error) => {
      const newState = { requesting: false, isError: true };
      if (error && error.message && error.message.includes('already exists.')) {
        newState.userExists = true;
      }
      this.setState(newState);
    };

    const onSuccess = () => {
      this.setState({ requesting: false, isDone: true });
    };

    this.setState({ requesting: true, isError: false, userExists: false });
    mutateRequestHSUser({
      variables: {
        input: {
          requestHSUser: {
            firstName,
            lastName,
            email,
            jobTitle,
            institutionName: node.name,
            institutionNCES: node.general.field_hs_na_nces_id,
            isCitizenOfEU,
            hasAgreedToTermsOfUse,
            hasAgreedToPrivacyPolicy,
          },
        },
      },
    }).then(onSuccess).catch(onFailure);
  };

  render() {
    const { isError, isDone, userExists, requesting } = this.state;
    const { node } = this.props;
    const linkBack = this.getLinkBack();
    const parentLinkBack = this.getParentLinkBack();
    if (!node) {
      return (
        <p data-cy="no-institution-found">
          <FormattedMessage id="institution.notFound" defaultMessage="No Institution Found" />
        </p>
      );
    } else {
      return (
        <div>
          {
            linkBack &&
            (<Link to={{ pathname: linkBack.pathname, state: { linkBack: parentLinkBack } }}><Icon name="angle left" />Back</Link>)
          }
          <Container text className="requestPrimaryUserPanel">
            <Header as="h1">
              <FormattedMessage
                id="hs-userRequest.header"
                description="Header for requesting an account for an existing institution"
                defaultMessage="Request User Account"
              />
            </Header>
            <RequestUserForm
              requesting={requesting}
              onSave={this._handleSave}
              onCancel={this._handleCancel}
              isError={isError}
              isDone={isDone}
              userExists={userExists}
              institutionName={node.name}
              onModalClose={this._handleDone}
              showJobTitle
              showAuthorizedToPost={false}
              showSchedulesVisits={false}
            />
          </Container>
        </div>
      );
    }
  }
}

const requestHSUserMutation = graphql(RequestHSUserMutation, {
  name: 'mutateRequestHSUser',
});

const query = gql`
  query Node($id: ID!) {
    node(id: $id) {
      ... on HighSchool {
        id
        name
        general {
          field_hs_na_nces_id
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ match }) => ({
    variables: {
      id: match.params.id,
    },
  }),
});

export const HSRequestUserPageComponent = withRouter(HSRequestUserPage);

export default withRouter(SimpleLoadingComponent(graphqlData, requestHSUserMutation)(HSRequestUserPageComponent));
